import { colors } from '../vars';

const get_color = (color: keyof typeof colors) => `${(colors as any)[color]}`;

export { get_color };
